<template>
  <div class="view-point-wrap" v-if="list.length > 0">
    <div class="title sepBottom S8 T1">相关视频</div>
    <div
      class="content sepBottom"
      v-for="(item, index) in list"
      :key="index"
      @click="goto(item.route)"
    >
      <div class="left">
        <div class="top S8 T1">{{ item.title }}</div>
        <div class="time S4 T3">
          {{ dayjs(item.startTime).format('YYYY-MM-DD') }}
        </div>
      </div>
      <div
        class="right"
        :style="{ backgroundImage: `url('${item.coverImg}')` }"
      ></div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'RelatedVideos',
  components: {},
  props: ['list'],
  computed: {},
  methods: {
    dayjs,
    // emitId(id) {
    //   this.$emit('emitId', id)
    // },
    goto(url) {
      location.replace(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.view-point-wrap {
  .content {
    margin: 0 30px;
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .left {
      display: flex;
      flex-direction: column;
      height: 150px;
      justify-content: space-between;
    }
    .right {
      width: 200px;
      height: 150px;
      border-radius: 5px;
      flex: none;
      margin-left: 58px;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .title {
    font-weight: 700;
    padding: 38px 0 38px 30px;
  }
}
</style>
